// DO NOT EDIT -- generated from fs/services/emissary/admin.proto

import { DeleteIntegrationConfigRequest } from './emissary.proto';
import * as matchmaker from '../matchmaker';
import * as orgs from '../orgs';

/** Admin-only endpoints used internally for troubleshooting and remediation. */
export namespace Admin {

  export const DeleteIntegrationConfigEndpoint = "/grpc/emissary.Admin/DeleteIntegrationConfig";
  /**
   * Deletes the given integration config, bypassing normal access control checks but still invoking
   * lifecycle hooks e.g. publishing the deleted integration config to Pub/Sub.
   */
  export function DeleteIntegrationConfig(sender: (req: DeleteIntegrationConfigRequest, endpoint: string) => Promise<{}>, req: DeleteIntegrationConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIntegrationConfigEndpoint),
      endpoint: DeleteIntegrationConfigEndpoint
    };
  }

  export const GetJiraCreateMetaEndpoint = "/grpc/emissary.Admin/GetJiraCreateMeta";
  export function GetJiraCreateMeta(sender: (req: GetJiraCreateMetaRequest, endpoint: string) => Promise<GetJiraCreateMetaResponse>, req: GetJiraCreateMetaRequest): { promise: () => Promise<GetJiraCreateMetaResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetJiraCreateMetaEndpoint),
      endpoint: GetJiraCreateMetaEndpoint
    };
  }

  export const GetOrgEndpoint = "/grpc/emissary.Admin/GetOrg";
  /** GetOrg is a manual proxy to the orgs service to get an org by ID. */
  export function GetOrg(sender: (req: orgs.OrgID, endpoint: string) => Promise<orgs.Org>, req: orgs.OrgID): { promise: () => Promise<orgs.Org>, endpoint: string } {
    return {
      promise: () => sender(req, GetOrgEndpoint),
      endpoint: GetOrgEndpoint
    };
  }

  export const GetAllSignalsEndpoint = "/grpc/emissary.Admin/GetAllSignals";
  /** GetAllSignals is a manual proxy to the matchmaker service to get all signals. */
  export function GetAllSignals(sender: (req: matchmaker.GetAllSignalsRequest, endpoint: string) => Promise<matchmaker.GetAllSignalsResponse>, req: matchmaker.GetAllSignalsRequest): { promise: () => Promise<matchmaker.GetAllSignalsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllSignalsEndpoint),
      endpoint: GetAllSignalsEndpoint
    };
  }

  export const BackfillConnectionsEndpoint = "/grpc/emissary.Admin/BackfillConnections";
  /**
   * BackfillConnections creates connections for mappings that do not have connections. Note that mappings or
   * integration configs with oauth will have connections created with the oauth auth type and the oauth object will
   * have a reference to the new connection. However, rest of the mappings will have connections created with
   * unauthenticated auth type.
   * This method is idempotent.
   */
  export function BackfillConnections(sender: (req: BackfillConnectionsRequest, endpoint: string) => Promise<BackfillConnectionsResponse>, req: BackfillConnectionsRequest): { promise: () => Promise<BackfillConnectionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BackfillConnectionsEndpoint),
      endpoint: BackfillConnectionsEndpoint
    };
  }
}

export interface GetJiraCreateMetaRequest {
  orgId: string;
  integrationId: string;
}

export interface GetJiraCreateMetaResponse {
  projects: GetJiraCreateMetaResponse.CreateMetaProject[];
}

export namespace GetJiraCreateMetaResponse {
  export interface CreateMetaProject {
    id: string;
    name: string;
    issueTypes: GetJiraCreateMetaResponse.CreateMetaProject.IssueType[];
  }

  export namespace CreateMetaProject {
    export interface IssueType {
      id: string;
      name: string;
      fields: GetJiraCreateMetaResponse.CreateMetaProject.IssueType.Field[];
    }

    export namespace IssueType {
      export interface Field {
        required: boolean;
        name: string;
        key: string;
        allowedValues: GetJiraCreateMetaResponse.CreateMetaProject.IssueType.Field.AllowedValue[];
        schema: GetJiraCreateMetaResponse.CreateMetaProject.IssueType.Field.FieldSchema | null;
      }

      export namespace Field {
        export interface AllowedValue {
          id: string;
          name: string;
          value: string;
          children: GetJiraCreateMetaResponse.CreateMetaProject.IssueType.Field.AllowedValue[];
        }

        export interface FieldSchema {
          type: string;
          items: string;
          system: string;
          custom: string;
        }
      }
    }
  }
}

export interface BackfillConnectionsRequest {
  orgId: string;
}

export interface BackfillConnectionsResponse {
  entities: BackfillConnectionsResponse.Backfill[];
}

export namespace BackfillConnectionsResponse {
  export enum BackfillType {
    BACKFILL_TYPE_INVALID = 0,
    /** Created an unauthenticated connection */
    BACKFILL_TYPE_UNAUTHENTICATED = 1,
    /** Created an OAuth connection */
    BACKFILL_TYPE_OAUTH = 2
  }

  export interface Backfill {
    mappingId: number;
    connectionId: number;
    configId: string;
    type: BackfillConnectionsResponse.BackfillType;
  }
}
